import { render, staticRenderFns } from "./AddCityToCompany.vue?vue&type=template&id=1079b80c&"
import script from "./AddCityToCompany.vue?vue&type=script&lang=js&"
export * from "./AddCityToCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports